import Joyride from 'react-joyride';

export default function TorchGuide({ steps, handleTorchGuideCallback, stepIndex }) {
  return (
    <Joyride
      steps={steps}
      stepIndex={stepIndex}
      continuous={true}
      scrollToFirstStep={true}
      disableCloseOnEsc={true}
      disableOverlayClose={true}
      showProgress={false}
      callback={handleTorchGuideCallback}
      styles={{
        options: {
          arrowColor: 'var(--q3-accent-normal)',
          backgroundColor: 'var(--q3-accent-normal)',
          overlayColor: 'rgba(0, 0, 0, 0.8)',
          primaryColor: 'var(--q3-accent-normal)',
          textColor: 'var(--q3-neutral-default_inverted)',
          width: 320,
          zIndex: 1000,
        },
        tooltip: {
          fontSize: '14px',
          padding: '12px',
          borderRadius: '16px',
          backgroundColor: 'var(--q3-accent-normal)',
        },
        tooltipContent: {
          padding: '0 0',
        },
        tooltipTitle: {
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '8px',
          color: 'var(--q3-neutral-default_inverted)',
        },
        tooltipFooter: {
          display: 'flex',
          marginTop: '16px',
          alignItems: 'start',
          justifyContent: 'space-between',
        },
        buttonBack: {
          flexShrink: 0,
          width: '36px',
          height: '36px',
          borderRadius: '9999px',
          backgroundColor: 'var(--q3-accent-normal)',
          border: '1px solid var(--q3-neutral-default_inverted)',
          color: 'var(--q3-neutral-default_inverted)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          padding: 0,
        },
        buttonNext: {
          flexGrow: 1,
          width: '100%',
          border: '1px solid var(--q3-neutral-default_inverted)',
          borderRadius: '25px',
          backgroundColor: 'var(--q3-accent-normal)',
          color: 'var(--q3-neutral-default_inverted)',
          fontSize: '14px',
          fontWeight: '500',
          padding: '10px 24px',
          cursor: 'pointer',
          transition: 'all 0.5s ease',
        },
        buttonSkip: {
          display: 'none',
        },
        buttonClose: {
          display: 'none',
        },
      }}
      locale={{
        back: '←',
        last: 'Finish',
        next: 'Next',
      }}
    />
  );
}
